import React from "react";
import LegalPage, { H2, P, UL } from "./LegalPage";

export default function Terms() {
  return (
    <LegalPage title="Terms & Conditions">

      <P>
        These Terms & Conditions govern your access to and use of the Grox24
        mobile application and website (“Platform”), including the Flavors smart
        meal planning feature.
      </P>

      <H2>1. Introduction</H2>
      <P>
        Welcome to Grox24. By using our platform, you agree to be bound by these
        Terms & Conditions. Please read them carefully before using the service.
      </P>

      <H2>2. Eligibility</H2>
      <P>
        You must be at least 18 years old and capable of entering into a legally
        binding agreement under Indian law to use this platform.
      </P>

      <H2>3. Account Registration</H2>
      <UL>
        <li>Users must provide accurate and complete information</li>
        <li>You are responsible for maintaining account confidentiality</li>
        <li>
          Grox24 reserves the right to suspend or terminate accounts for misuse
          or fraudulent activity
        </li>
      </UL>

      <H2>4. Products & Services</H2>
      <P>Grox24 provides:</P>
      <UL>
        <li>Online grocery ordering</li>
        <li>Delivery of fresh produce and essentials</li>
        <li>Signature Fresh™ clean system processing</li>
        <li>Flavors smart nutrition and meal planning feature</li>
      </UL>
      <P>Product availability is subject to stock and location.</P>

      <H2>5. Orders & Payments</H2>
      <UL>
        <li>Orders confirmed only after successful payment or COD confirmation</li>
        <li>Prices may change without prior notice</li>
        <li>
          Grox24 may cancel orders due to pricing errors, stock issues, or
          suspected fraud
        </li>
        <li>Payments processed via secure third-party gateways</li>
      </UL>

      <H2>6. Signature Fresh™ Clean System</H2>
      <P>
        Grox24 applies its proprietary Signature Fresh™ cleaning process to
        selected produce items. While we take reasonable hygiene measures, we do
        not guarantee complete elimination of all contaminants.
      </P>

      <H2>7. Flavors – Smart Nutrition Feature</H2>
      <P>Flavors provides:</P>
      <UL>
        <li>Recipe suggestions</li>
        <li>Meal planning guidance</li>
        <li>Portion adjustments based on family size</li>
      </UL>
      <P>
        Flavors content is for informational purposes only and does not
        constitute medical or dietary advice. Users with medical conditions
        should consult healthcare professionals before making dietary changes.
      </P>

      <H2>8. Delivery</H2>
      <UL>
        <li>Delivery timelines are estimates and may vary</li>
        <li>Users must ensure availability at delivery location</li>
        <li>
          Grox24 is not liable for delays caused by events beyond reasonable
          control
        </li>
      </UL>

      <H2>9. Intellectual Property</H2>
      <P>
        All content, branding, trademarks, designs, software, and proprietary
        processes including Signature Fresh™ and Flavors are owned by Grox24 and
        protected under applicable laws.
      </P>

      <H2>10. Limitation of Liability</H2>
      <P>Grox24 shall not be liable for:</P>
      <UL>
        <li>Indirect or consequential damages</li>
        <li>Health issues arising from misuse of products</li>
        <li>Service disruptions beyond reasonable control</li>
      </UL>

      <H2>11. Governing Law</H2>
      <P>
        These Terms shall be governed by the laws of India. Any disputes shall be
        subject to the jurisdiction of courts in Tamil Nadu.
      </P>

    </LegalPage>
  );
}